import * as React from 'react';
import { ITutorialProps } from './types';
import './_Tutorial.scss';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import { TUTORIALS_VIDEO_URL_MAP } from './constants';
import { LoaderBlock } from 'kui';

export function Tutorial ({
    boardSetting,
    onFinish,
    onPlay,
}: ITutorialProps) {
    const className = CLASS_BOARD_DETAILS + '-tutorial';

    const playerRef = React.useRef(null);
    const playedRef = React.useRef(false);

    const onLoadVideo = () => {
        if (playerRef.current) return;
        //@ts-ignore
        playerRef.current = new window.YT.Player('yt-player-tutorial', {
            videoId: TUTORIALS_VIDEO_URL_MAP[boardSetting],
            playerVars: {},
            events: {
                onStateChange: (e: any) => {
                    const state = e.target.getPlayerState();
                    if (state === 1 && !playedRef.current) {
                        playedRef.current = true;
                        onPlay(boardSetting);
                    } else if (state === 0) {
                        onFinish(boardSetting);
                    }
                }
            }
        });
    };

    React.useEffect(() => {
        //@ts-ignore
        if (!window.YT) {
            if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) return;
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            //@ts-ignore
            window.onYouTubeIframeAPIReady = onLoadVideo;
            const firstScriptTag = document.getElementsByTagName('script')[0];
            tag.onerror = () => {
                document.documentElement.classList.add('yt-disabled');
            };
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
            onLoadVideo();
        }
    }, []);

    return <div className={className}>
        <LoaderBlock />
        <div id={'yt-player-tutorial'} />
    </div>;
};
